import React from 'react';

const MovimentoEntrUsc =  ({ tipo, showLabel = false, otherLabel = 'All' }) => {

    if (tipo === 'E') {
        if (showLabel) {
            return (
                <div><i className="sign in green icon" title="Movimento in Entrata"/> Entrate</div> )
        }
        else {
            return (
                <i className="sign in green icon" title="Movimento in Entrata"/>)
        }
    }
    else if (tipo === 'U') {
        if (showLabel) {
            return (
                <div><i className="sign out red icon" title="Movimento in Uscita"/> Uscite</div> )
        }
        else {
            return (
                <i className="sign out red icon" title="Movimento in Uscita"/>)
        }
    }
    else {
        if (showLabel) {
            return (
                <div> {otherLabel}</div> )
        }
        else {
            return ( <div></div>)
        }
    }
}

export default MovimentoEntrUsc;


/** WEBPACK FOOTER **
 ** ./src/components/movimenti/MovimentoEntrUsc.js
 **/